import { render, staticRenderFns } from "./TabletPreview.vue?vue&type=template&id=382e299c&scoped=true"
import script from "./TabletPreview.vue?vue&type=script&lang=js"
export * from "./TabletPreview.vue?vue&type=script&lang=js"
import style0 from "./TabletPreview.vue?vue&type=style&index=0&id=382e299c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382e299c",
  null
  
)

export default component.exports